

export default function ComparisonTableName({ keyValue='', title='' }) {

  return (
    <div key={keyValue} className="mt-3 h-12 flex items-center">
      <h3 className="text-base md:text-lg tracking-tight font-medium text-gray-900 text-center line-clamp-2">
        {title}
      </h3>
    </div>
  )
}

//  line-clamp-2